/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import { cssMap, jsx } from '@atlaskit/css';
import LinkIcon from '@atlaskit/icon/core/migration/link';
import { token } from '@atlaskit/tokens';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { Label } from '@atlaskit/form';
import Textfield from '@atlaskit/textfield';
import InlineDialog from '@atlaskit/inline-dialog';
import CheckCircleIcon from '@atlaskit/icon/core/migration/success--check-circle';

import { InstrumentedCustomThemeButton as InstrumentedButton } from '../../analytics/InstrumentedButton';
import { messages } from '../i18n';

const styles = cssMap({
	wrapper: {
		marginBlockStart: token('space.200', '16px'),
	},
});

export const CopyInviteLink: React.FC<{
	handleCopyLink: () => void;
	activeInviteLink?: string;
	isInviteLinkCopied: boolean;
}> = ({ handleCopyLink, activeInviteLink, isInviteLinkCopied }) => {
	const popupContent = (
		<Inline space="space.100">
			<CheckCircleIcon
				label=""
				color={token('color.icon.success')}
				LEGACY_size="medium"
				spacing="spacious"
			/>
			<Text>
				<FormattedMessage {...messages.copyInviteButtonCopiedLabel} />
			</Text>
		</Inline>
	);

	return (
		<Stack xcss={styles.wrapper} space="space.050">
			<Label htmlFor="copyLink">
				<FormattedMessage {...messages.inviteLinkLabel} />
			</Label>
			<Inline space="space.100" alignBlock="center">
				<Textfield
					id="copyLink"
					isReadOnly={true}
					value={activeInviteLink}
					isDisabled={!activeInviteLink}
					testId="testId-shareablelink-link-textfield"
				/>
				<Box>
					<InlineDialog content={popupContent} isOpen={isInviteLinkCopied} placement="bottom">
						<InstrumentedButton
							onClick={handleCopyLink}
							iconBefore={
								<LinkIcon color="currentColor" label="" LEGACY_size="medium" spacing="spacious" />
							}
							style={{
								// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
								backgroundColor: token('color.background.neutral'),
								padding: `0 ${token('space.150', '12px')} 0 ${token('space.100', '8px')}`,
							}}
							actionSubjectId="copyInviteLinkButton"
							testId="testId-shareablelink-copy-button"
						>
							<FormattedMessage {...messages.copyInviteButtonLabel} />
						</InstrumentedButton>
					</InlineDialog>
				</Box>
			</Inline>
			<Text color="color.text.subtlest" size="small">
				<FormattedMessage {...messages.shareableLinkSubMessageLabel} />
			</Text>
		</Stack>
	);
};
